import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { ReservationSession } from "../types/session";

interface SessionStore {
  session: ReservationSession | null;
  setSession: (session: ReservationSession | null) => void;
  clearSession: () => void;
}

export const useSessionStore = create<SessionStore>()(
  persist(
    (set) => ({
      session: null,
      setSession: (session) => set({ session }),
      clearSession: () => set({ session: null }),
    }),
    {
      name: "reservation-session",
      partialize: (state) => ({ session: state.session }),
    },
  ),
);
